import styled from '@emotion/styled';

export default styled.label`
  color: ${(props) => props.theme.colors.text} !important;
  font-weight: 300 !important;
  margin: 0;
  padding: 0;
`;
